import {Component, Input} from "@angular/core";

@Component({
  selector: 'app-onboarding-stepper',
  templateUrl: './onboarding-stepper.component.html',
  styleUrls: ['./onboarding-stepper.component.scss']
})
export class OnboardingStepperComponent {
  private _currentStep: number = 0;
  private _steps: number[] = [0, 1, 2, 3];

  get steps(): number[] {
    return this._steps;
  }

  get currentStep(): number {
    return this._currentStep;
  }

  @Input({required: true})
  set currentStep(value: number) {
    this._currentStep = value;
  }
}
